import React, { useEffect, useState, useCallback } from "react";
import {
  Container,
  Grid,
  TextField,
  Modal,
  Button,
  IconButton,
  InputAdornment,
  Paper,
  Box,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TablePagination,
  Tooltip,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import dayjs from "dayjs";
import { jsPDF } from "jspdf";
import { Navigate, useNavigate } from "react-router-dom";

const LeavingCertificate = () => {
  let navigate = useNavigate();
  const [studentId, setStudentId] = useState("");
  const [selectedStudentName, setSelectedStudentName] = useState("");
  const [leavingDate, setLeavingDate] = useState("");
  const [reasonForLeaving, setReasonForLeaving] = useState("");
  const [lastClassAttended, setLastClassAttended] = useState("");
  const [remarks, setRemarks] = useState("");
  const [ddlClass, setDdlClass] = useState([]);
  const [ddlStudent, setDdlStudent] = useState([]);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [openStudentModal, setOpenStudentModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [selectedClass, setSelectedClass] = useState("");


 const filteredStudents = ddlStudent.filter((student) => {
  const searchLower = searchQuery.toLowerCase();
  const classMatch = selectedClass ? student.className === selectedClass : true;
  return classMatch && (
    student.studentName.toLowerCase().includes(searchLower) ||
    student.admissionNo.toLowerCase().includes(searchLower) ||
    student.className.toLowerCase().includes(searchLower) ||
    student.sectionName.toLowerCase().includes(searchLower) ||
    student.rollNo.toLowerCase().includes(searchLower) ||
    student.fatherName.toLowerCase().includes(searchLower)
  );
});


  const paginatedStudents = filteredStudents.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

 const fetchStudent = async () => {
  try {
    const apiUrl = process.env.REACT_APP_BASE_URL;
    const token = sessionStorage.getItem("token");
    const response = await fetch(`${apiUrl}/SLC/GetStudentList_SLC`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify({
        classId: "0",
      }),
    });
    if (!response.ok) {
      throw new Error(`Error fetching students: ${response.status}`);
    }
    const data = await response.json();
    if (data.data === null && data.msg === "Record Not Found") {
      setDdlStudent([]);
      return;
    }
    // Ensure we always set an array
    setDdlStudent(Array.isArray(data) ? data : data.data || []);
  } catch (error) {
    console.error(error);
    setDdlStudent([]); // Always set empty array on error
  }
};

 const fetchClass = async () => {
  try {
    const apiUrl = process.env.REACT_APP_BASE_URL;
    const token = sessionStorage.getItem("token");
    const response = await fetch(`${apiUrl}/Enquiry/ddlClassName`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify({}),
    });
    if (!response.ok) {
      throw new Error(`Error fetching classes: ${response.status}`);
    }
    const data = await response.json();
    if (data.data === null && data.msg === "Record Not Found") {
      setDdlClass([]);
      return;
    }
    // Ensure we always set an array
    setDdlClass(Array.isArray(data) ? data : data.data || []);
  } catch (error) {
    console.error(error);
    setDdlClass([]); // Always set empty array on error
  }
};

  useEffect(() => {
    fetchClass();
    fetchStudent();
  }, []);

  const handleCancel = () => {
    setStudentId("");
    setSelectedStudentName("");
    setLeavingDate("");
    setReasonForLeaving("");
    setLastClassAttended("");
    setRemarks("");
  };

  const handleSubmit = async () => {
    try {
      const url = process.env.REACT_APP_BASE_URL;
      const apiUrl = `${url}/SLC/generate-slc`;
      const token = sessionStorage.getItem("token");

      const formattedDate = dayjs(leavingDate).format("YYYY-MM-DD");

      const payload = {
        studentId: parseInt(studentId),
        leavingDate: formattedDate,
        reasonForLeaving: reasonForLeaving,
        lastClassAttended: lastClassAttended,
        remarks: remarks,
      };

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok && data.message === "SLC generated successfully") {
        const updatedStudents = [...ddlStudent];
        const studentIndex = updatedStudents.findIndex(
          (student) => student.studentId === parseInt(studentId)
        );

        if (studentIndex !== -1) {
          updatedStudents.splice(studentIndex, 1);
          setDdlStudent(updatedStudents);
        }

        setOpenSuccessModal(true);
      } else if (data.message === "SLC already exists for this student.") {
        setOpenErrorModal(true);
      } else {
        throw new Error(`Error generating SLC: ${response.status}`);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const handleCloseModal = () => {
    setOpenSuccessModal(false);
    setOpenErrorModal(false);
    handleCancel();
  };

  const handleViewSLC = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const url = process.env.REACT_APP_BASE_URL;
      const apiUrl = `${url}/SLC/get-slc/${studentId}`;

      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      if (data && data.length > 0) {
        generatePDF(data);
      } else {
        console.error("No SLC data returned for the student");
      }
    } catch (error) {
      console.error("Error fetching the PDF:", error);
    }
  };

 const generatePDF = useCallback(async (data) => {
    // Helper function to convert date to words
    const convertDateToWords = (dateStr) => {
      if (!dateStr || typeof dateStr !== 'string') return "N/A";

      const dateParts = dateStr.split(/[/\s:]+/);
      let day, month, year;

      if (dateParts.length > 3) {
        [month, day, year] = dateParts;
      } else {
        [day, month, year] = dateParts;
      }

      day = parseInt(day, 10);
      month = parseInt(month, 10);
      year = parseInt(year, 10);

      if (isNaN(day) || isNaN(month) || isNaN(year)) return "Invalid Date";

      const ones = ["", "First", "Second", "Third", "Fourth", "Fifth", "Sixth", "Seventh", "Eighth", "Ninth"];
      const tens = ["", "Tenth", "Eleventh", "Twelfth", "Thirteenth", "Fourteenth", "Fifteenth", "Sixteenth", "Seventeenth", "Eighteenth", "Nineteenth"];
      const twenties = ["", "", "Twentieth", "Thirtieth"];
      let dayInWords = "";
      if (day <= 19) {
        dayInWords = day < 10 ? ones[day] : tens[day - 10];
      } else {
        const dayTens = Math.floor(day / 10);
        const dayOnes = day % 10;
        dayInWords = (dayTens <= 3 ? twenties[dayTens] : ones[dayTens] + "ieth").replace("Fifth", "Fifth").replace("Ninth", "Ninth");
        if (dayOnes > 0) dayInWords = dayInWords.replace(/ieth$/, "") + "-" + ones[dayOnes].toLowerCase();
      }

      const months = ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
      const monthInWords = months[month] || "Unknown Month";

      const yearToWords = (year) => {
        const numWords = {
          0: "Zero", 1: "One", 2: "Two", 3: "Three", 4: "Four", 5: "Five",
          6: "Six", 7: "Seven", 8: "Eight", 9: "Ninth", 10: "Ten",
          11: "Eleven", 12: "Twelve", 13: "Thirteen", 14: "Fourteen", 15: "Fifteen",
          16: "Sixteen", 17: "Seventeen", 18: "Eighteen", 19: "Nineteen",
          20: "Twenty", 30: "Thirty", 40: "Forty", 50: "Fifty",
          60: "Sixty", 70: "Seventy", 80: "Eighty", 90: "Ninety"
        };
        if (year < 20) return numWords[year];
        if (year < 100) {
          const tensPart = Math.floor(year / 10) * 10;
          const onesPart = year % 10;
          return onesPart ? `${numWords[tensPart]}-${numWords[onesPart].toLowerCase()}` : numWords[tensPart];
        }
        if (year < 1000) {
          const hundreds = Math.floor(year / 100);
          const remainder = year % 100;
          return remainder ? `${numWords[hundreds]} Hundred ${yearToWords(remainder)}` : `${numWords[hundreds]} Hundred`;
        }
        if (year < 10000) {
          const thousands = Math.floor(year / 1000);
          const remainder = year % 1000;
          return remainder ? `${numWords[thousands]} Thousand ${yearToWords(remainder)}` : `${numWords[thousands]} Thousand`;
        }
        return "Year Out of Range";
      };
      const yearInWords = yearToWords(year);

      return `${dayInWords} ${monthInWords} ${yearInWords}`;
    };

    try {
      const doc = new jsPDF("p", "mm", "a4");

      // Add custom font (fallback to Helvetica if font loading fails)
      doc.setFont("helvetica", "normal");

      // Add borders with rounded corners
      doc.setDrawColor(0, 51, 102); // Primary blue
      doc.setLineWidth(1.2);
      doc.roundedRect(8, 8, 194, 281, 3, 3); // Outer rounded border
      doc.setDrawColor(0, 102, 204); // Lighter blue
      doc.setLineWidth(0.4);
      doc.roundedRect(12, 12, 186, 273, 2, 2); // Inner rounded border

      // Add logo to PDF (if available)
      let logoDataUrl = null;
      let imageFormat = 'PNG';
      try {
        const token = sessionStorage.getItem("token");
        if (!token) throw new Error("No authentication token found");
        const response = await fetch('https://wsmsv1.aidigitalsec.com/api/FeeReport/GetSchoolName', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token,
          },
          body: JSON.stringify({}),
        });
        if (!response.ok) throw new Error(`API error: ${response.status} ${response.statusText}`);
        const apiData = await response.json();
        const logoImg = apiData[0]?.logoImg;

        if (logoImg && typeof logoImg === 'string' && logoImg.trim() !== '') {
          let cleanedBase64 = logoImg
            .replace(/^data:image\/[a-zA-Z]+;base64,/, '')
            .replace(/\s/g, '')
            .replace(/\n/g, '');
          const paddingLength = (4 - (cleanedBase64.length % 4)) % 4;
          cleanedBase64 += '='.repeat(paddingLength);

          const isValidBase64 = /^[A-Za-z0-9+/=]+$/.test(cleanedBase64);
          if (!isValidBase64) {
            console.error('Invalid base64 string for logoImg:', cleanedBase64.substring(0, 100) + '...');
            throw new Error('Invalid base64 string for logoImg');
          }

          // Log base64 for debugging
          console.log('Logo base64 (first 100 chars):', cleanedBase64.substring(0, 100) + '...');
          console.log('Full logo base64 length:', cleanedBase64.length);

          // Force PNG format
          imageFormat = 'PNG';
          logoDataUrl = `data:image/png;base64,${cleanedBase64}`;

          try {
            // Add larger white background to cover potential edge artifacts
            doc.setFillColor(255, 255, 255);
            doc.rect(14, 14, 27, 27, "F"); // Slightly larger than logo (25x25 at 15,15)
            // Add logo
            doc.addImage(logoDataUrl, 'PNG', 15, 15, 25, 25);
          } catch (error) {
            console.error('Error adding logo to PDF (PNG):', error.message);
            console.warn('The logo image may have an embedded grey background. Falling back to transparent placeholder.');
            // Fallback to a transparent 1x1 PNG
            const transparentPlaceholder = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAA1JREFUGFdjYGBgYAAAAAUAAY+SkSAAAAAASUVORK5CYII=';
            doc.setFillColor(255, 255, 255);
            doc.rect(14, 14, 27, 27, "F");
            doc.addImage(transparentPlaceholder, 'PNG', 15, 15, 25, 25);
          }
        } else {
          console.warn('No valid logo image found. Using transparent placeholder.');
          // Fallback to a transparent 1x1 PNG
          const transparentPlaceholder = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAA1JREFUGFdjYGBgYAAAAAUAAY+SkSAAAAAASUVORK5CYII=';
          doc.setFillColor(255, 255, 255);
          doc.rect(14, 14, 27, 27, "F");
          doc.addImage(transparentPlaceholder, 'PNG', 15, 15, 25, 25);
        }
      } catch (error) {
        console.error('Error fetching or processing logo:', error);
        console.warn('Using transparent placeholder due to logo fetch error.');
        // Fallback to a transparent 1x1 PNG
        const transparentPlaceholder = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAA1JREFUGFdjYGBgYAAAAAUAAY+SkSAAAAAASUVORK5CYII=';
        doc.setFillColor(255, 255, 255);
        doc.rect(14, 14, 27, 27, "F");
        doc.addImage(transparentPlaceholder, 'PNG', 15, 15, 25, 25);
      }

      // School information
      const schoolName = (sessionStorage.getItem("organizationName")?.replace(/['"]+/g, "") || "School Name");
      const schoolAddress = sessionStorage.getItem("address")?.replace(/['"]+/g, "") || "School Address";
      const contactInfo = sessionStorage.getItem("phoneNo")?.replace(/['"]+/g, "") || "N/A";
      const contactInfoWithLabel = `Phone No: ${contactInfo}`;

      // School Name
      doc.setFont("helvetica", "bold");
      doc.setFontSize(22);
      doc.setTextColor(0, 51, 102);
      const maxSchoolNameWidth = 140;
      const splitSchoolName = doc.splitTextToSize(schoolName, maxSchoolNameWidth);

      // Calculate position for (Registered)
      const schoolNameWidth = doc.getTextWidth(splitSchoolName[0]);
      const registeredX = 58 + schoolNameWidth + 2; // 2 units padding after school name

      // Draw school name
      doc.text(splitSchoolName, 55, 22);

      // Add (Registered) in lighter style
      doc.setFontSize(12); // Smaller size
      doc.setTextColor(100, 100, 100); // Gray color
      doc.text("(Registered)", registeredX, 22);

      // Reset styles
      doc.setFontSize(22);
      doc.setTextColor(0, 51, 102);

      const schoolNameHeight = splitSchoolName.length * 8;

      // Rest of your existing code remains exactly the same...
      doc.setFontSize(11);
      doc.setFont("helvetica", "normal");
      doc.setTextColor(50, 50, 50);
      const addressStartX = 55;
      const maxAddressWidth = 140;
      const splitAddressText = doc.splitTextToSize(schoolAddress, maxAddressWidth);
      const addressLine1 = splitAddressText[0] || "";
      const addressLine2 = splitAddressText[1] || "";
      const addressY1 = 20 + schoolNameHeight + 3;
      const addressY2 = addressY1 + 5;
      doc.text(addressLine1, addressStartX, addressY1);
      doc.text(addressLine2, addressStartX, addressY2);

      // Contact Number (Moved to left)
      doc.setFontSize(11);
      const contactY = addressY2 + 6;
      doc.text(contactInfoWithLabel, 55, contactY, { align: "left" });
      // Decorative divider
      doc.setDrawColor(0, 51, 102);
      doc.setLineWidth(0.3);
      const dividerY = contactY + 10; // Increased clearance to avoid logo overlap
      doc.setFillColor(0, 51, 102, 0.2);
      doc.rect(20, dividerY - 1, 170, 1, "F"); // Subtle filled rectangle for divider

      // Title
      doc.setFontSize(30);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(0, 51, 102);
      const titleY = dividerY + 15;
      doc.text("School Leaving Certificate", 105, titleY, { align: "center" });

      // Sub-title
      doc.setFontSize(13);
      doc.setFont("helvetica", "italic");
      doc.setTextColor(50, 50, 50);
      const subtitleY = titleY + 8;
      doc.text("This certifies that the following student has left the institution:", 105, subtitleY, { align: "center" });

      // TC Number
      const tcNo = data && data.length > 0 ? `TC.NO: ${data[0].slcId}` : "TC.NO: N/A";
      doc.setFontSize(11);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(0, 51, 102);
      const tcNoY = subtitleY + 6;
      doc.text(tcNo, 18, tcNoY);

      // TC Number underline
      doc.setDrawColor(0, 51, 102);
      doc.setLineWidth(0.2);
      const tcNoLineY = tcNoY + 2;
      doc.line(15, tcNoLineY, 41, tcNoLineY);

      // Content
      doc.setFontSize(11);
      doc.setTextColor(0, 0, 0);
      let contentY = tcNoLineY + 12;

      if (data && data.length > 0) {
        const slc = data[0];
        const dobInWords = convertDateToWords(slc.studentDob);
        const details = [
          { label: "Student Name", value: slc.studentName },
          { label: "Admission No", value: slc.admissionNo },
          { label: "Aadhar No.", value: slc.adhaarNo },
          { label: "Father's Name", value: slc.fathersName },
          { label: "Mother's Name", value: slc.mothersName },
          { label: "Student DOB", value: slc.studentDob },
          { label: "in words", value: dobInWords },
          { label: "Place of Birth", value: "" },
          { label: "Address", value: slc.address },
          { label: "Religion", value: "" },
          { label: "Admission Date", value: slc.admissionDate },
          { label: "Leaving Date", value: slc.leavingDate },
          { label: "Reason for Leaving", value: slc.reasonForLeaving },
          { label: "Last Class Attended", value: slc.lastClassAttended },
          { label: "Remarks", value: slc.remarks },
          { label: "Dues Amount", value: slc.duesAmount },
          { label: "Issued Date", value: slc.issuedDate },
        ];

        const maxWidth = 120;
        const pageHeight = 277;
        const bottomMargin = 25;

        details.forEach(({ label, value }) => {
          const valueStr = value !== undefined && value !== null ? String(value) : "N/A";

          if (contentY + 12 > pageHeight - bottomMargin) {
            doc.addPage();
            contentY = 15;
            doc.setDrawColor(0, 51, 102);
            doc.setLineWidth(1.2);
            doc.roundedRect(8, 8, 194, 281, 3, 3);
            doc.setDrawColor(0, 102, 204);
            doc.setLineWidth(0.4);
            doc.roundedRect(12, 12, 186, 273, 2, 2);
          }

          doc.setFont("helvetica", "bold");
          doc.text(`${label}:`, 15, contentY);

          if (label === "Religion") {
            let currentX = 65;
            const y = contentY;
            doc.setFont("helvetica", "normal");
            const religionName = slc.religionName && slc.religionName.trim() !== "" ? slc.religionName : "N/A";
            doc.text(religionName, currentX, y);
            currentX += doc.getTextWidth(religionName) + 6;
            doc.setFont("helvetica", "bold");
            doc.text("Caste:", currentX, y);
            const casteLabelWidth = doc.getTextWidth("Caste:");
            doc.setFont("helvetica", "normal");
            const casteName = slc.casteName && slc.casteName.trim() !== "" ? slc.casteName : "N/A";
            doc.text(casteName, currentX + casteLabelWidth, y);
          } else if (label === "Place of Birth") {
            let currentX = 65;
            const y = contentY;
            doc.setFont("helvetica", "normal");
            const cityName = slc.cityName && slc.cityName.trim() !== "" ? slc.cityName : "N/A";
            doc.text(cityName, currentX, y);
            currentX += doc.getTextWidth(cityName) + 4;
            doc.setFont("helvetica", "bold");
            doc.text("State:", currentX, y);
            const stateLabelWidth = doc.getTextWidth("State:");
            doc.setFont("helvetica", "normal");
            const stateName = slc.stateName && slc.stateName.trim() !== "" ? slc.stateName : "N/A";
            doc.text(stateName, currentX + stateLabelWidth, y);
            currentX += stateLabelWidth + doc.getTextWidth(stateName) + 6; // Increased gap to 6mm
            doc.setFont("helvetica", "bold");
            doc.text("Country:", currentX, y);
            const countryLabelWidth = doc.getTextWidth("Country:");
            doc.setFont("helvetica", "normal");
            const countryName = slc.countyName && slc.countyName.trim() !== "" ? slc.countyName : "N/A";
            doc.text(countryName, currentX + countryLabelWidth, y);
            currentX += countryLabelWidth + doc.getTextWidth(countryName) + 4;
            doc.setFont("helvetica", "bold");
            doc.text("Nationality:", currentX, y);
            const nationalityLabelWidth = doc.getTextWidth("Nationality:");
            doc.setFont("helvetica", "normal");
            const nationality = slc.nationality && slc.nationality.trim() !== "" ? slc.nationality : "N/A";
            doc.text(nationality, currentX + nationalityLabelWidth, y);
          } else {
            doc.setFont("helvetica", "normal");
            const splitText = doc.splitTextToSize(valueStr, maxWidth);
            doc.text(splitText, 65, contentY);
            contentY += (splitText.length - 1) * 6;
          }

          contentY += 8; // Tighter spacing for cleaner look
        });

        // Footer
        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.setTextColor(60, 60, 60);
        doc.text('Certified that, above information is in accordance with the College Register.', 105, 236, { align: "center" });
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        const penaltyText = '(No change in any entry shall be made except by the authority issuing it and';
        const penaltyText2 = 'any infringement of the requirement is liable to involve the imposition of penalty such as that of rustication)';
        const splitPenaltyText = doc.splitTextToSize(penaltyText, 170);
        const splitPenaltyText2 = doc.splitTextToSize(penaltyText2, 170);
        doc.text(splitPenaltyText, 105, 244, { align: "center" });
        doc.text(splitPenaltyText2, 105, 249, { align: "center" });

        doc.setFontSize(11);
        doc.setFont("helvetica", "italic");
        doc.setTextColor(0, 51, 102);
        doc.text("Principal Signature", 145, 270);
        doc.setDrawColor(0, 51, 102);
        doc.setLineWidth(0.2);
        doc.line(135, 265, 185, 265);
      } else {
        console.error("Data array is empty or not defined");
      }

      // Output PDF
      const pdfBlob = doc.output("blob");
      const pdfUrl = URL.createObjectURL(pdfBlob);
      window.open(pdfUrl, "_blank");
      // Save the PDF
      // doc.save("slc.pdf");
    } catch (error) {
      console.error("Error generating the PDF:", error);
    }
  }, []);

  const handleOpenStudentModal = () => setOpenStudentModal(true);

  const handleSelectStudent = (student) => {
    setStudentId(student.studentId);
    setSelectedStudentName(student.studentName);
    setOpenStudentModal(false);
  };

  // ADDED: Back button handler
  const handleBack = () => {
    navigate(-1);
  };

  return (
    <Container maxWidth="md" style={{ marginTop: "30px" }}>
      <Box
          sx={{
            backgroundColor: '#0B1F40', // dark navy blue
            padding: '12px 24px',
            boxShadow: 3,
            borderRadius: '4px 4px 0 0',
            margin: '2px auto',
           maxWidth: "900px",
          }}
        >
          <Typography variant="h4" sx={{ color: '#fff', textAlign:'center', fontWeight: 'bold' }}>
        School Leaving Form
      </Typography> </Box>
      <Paper elevation={3} style={{ padding: "20px", marginTop:6}}>
      
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Selected Student"
              value={selectedStudentName}
              fullWidth
              variant="outlined"
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={handleOpenStudentModal}>
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Leaving Date"
              type="date"
              value={leavingDate}
              onChange={(e) => setLeavingDate(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
              fullWidth
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Reason for Leaving"
              value={reasonForLeaving}
              onChange={(e) => setReasonForLeaving(e.target.value)}
              fullWidth
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth variant="outlined">
              <InputLabel>Last Class Attended</InputLabel>
              <Select
                value={lastClassAttended}
                onChange={(e) => setLastClassAttended(e.target.value)}
                label="Last Class Attended"
              >
                <MenuItem value="">
                  <em>Select</em>
                </MenuItem>
                {ddlClass.map((item) => (
                  <MenuItem key={item.classId} value={item.className}>
                    {item.className}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Remarks"
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              fullWidth
              variant="outlined"
              multiline
              rows={4}
            />
          </Grid>
          <Grid item xs={12} style={{ textAlign: "center" }}>
            <Tooltip title={(!studentId || !leavingDate || !reasonForLeaving || !lastClassAttended) && "Please fill the required fields"} arrow>
              <span>
                <Button
                  variant="contained"
                  sx={{ marginRight: "16px" }}
                  color="error"
                  onClick={handleSubmit}
                  disabled={!studentId || !leavingDate || !reasonForLeaving || !lastClassAttended}
                >
                  Generate SLC
                </Button>
              </span>
            </Tooltip>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#2196f3",
                "&:hover": { backgroundColor: "#1976d2" },
                marginRight: "16px",
              }}
              color="secondary"
              onClick={handleCancel}
            >
              RESET
            </Button>
            {/* UPDATED: Back button — filled navy #0B1F40 to match the page header color */}
            <Button
              variant="contained"
              startIcon={<ArrowBackIcon />}
              onClick={handleBack}
              sx={{
                backgroundColor: '#0B1F40',
                color: '#fff',
                fontWeight: 'bold',
                '&:hover': {
                  backgroundColor: '#16305e',
                },
              }}
            >
              Back
            </Button>
          </Grid>
        </Grid>
      </Paper>

      <Dialog
        open={openStudentModal}
        onClose={() => setOpenStudentModal(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Select Student</DialogTitle>
       <DialogContent>
  <Box sx={{ display: 'flex', gap: 2, marginBottom: "20px", marginTop: '20px' }}>
    <TextField
      label="Search Students"
      variant="outlined"
      fullWidth
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
      sx={{ flex: 1 }} // Decrease width to make space for the dropdown
    />
    <FormControl sx={{ minWidth: 150 }}>
      <InputLabel>Class</InputLabel>
      <Select
        value={selectedClass}
        onChange={(e) => setSelectedClass(e.target.value)}
        label="Class"
      >
        <MenuItem value="">All Classes</MenuItem>
        {ddlClass.map((cls) => (
          <MenuItem key={cls.classId} value={cls.className}>
            {cls.className}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Box>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Admission No</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Class</TableCell>
                  <TableCell>Section</TableCell>
                  <TableCell>Roll No</TableCell>
                  <TableCell>Father's Name</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedStudents.map((student) => (
                  <TableRow key={student.studentId}>
                    <TableCell>{student.admissionNo}</TableCell>
                    <TableCell>{student.studentName}</TableCell>
                    <TableCell>{student.className}</TableCell>
                    <TableCell>{student.sectionName}</TableCell>
                    <TableCell>{student.rollNo}</TableCell>
                    <TableCell>{student.fatherName}</TableCell>
                    <TableCell>
                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => handleSelectStudent(student)}
                      >
                        Select
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
                {paginatedStudents.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      No students found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredStudents.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setSearchQuery("");
              setPage(0);
              setOpenStudentModal(false);
            }}
            color="secondary"
            variant="contained"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

     <Modal
  open={openSuccessModal}
  onClose={handleCloseModal}
  aria-labelledby="success-modal-title"
  aria-describedby="success-modal-description"
>
  <Box
    sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 400,
      bgcolor: 'background.paper',
      borderRadius: 2,
      boxShadow: 24,
      overflow: 'hidden',
    }}
  >
    {/* Header */}
    <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
      <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
       SLC Generated ✅
      </Typography>
    </Box>

    {/* Content */}
    <Box sx={{ padding: '20px' }}>
      <Typography id="success-modal-description" sx={{ mb: 2 }}>
        The Schoool Leaving Cerficate has been generated successfully.
      </Typography>

      {/* Buttons */}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap:1, mt: 3 }}>
         <Button
          onClick={handleViewSLC}
          variant="contained"
          color="primary"
        >
          VIEW
        </Button>
        {/* FIXED: CLOSE button now correctly calls handleCloseModal to close the modal and reset the form */}
        <Button
          onClick={handleCloseModal}
          variant="contained"
          color="error"
        >
          CLOSE
        </Button>
      </Box>
    </Box>
  </Box>
</Modal>

      <Dialog open={openErrorModal} onClose={handleCloseModal}>
        <DialogTitle>{"SLC Already Exists"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            An SLC already exists for this student.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseModal}
            color="secondary"
            variant="contained"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default LeavingCertificate;


